import { ChipInput } from "../Elements";
import { InputComponentProps } from "./Filters";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Display_Value_Key as dvk } from "../Create/utils";

// Text input component
const RenderTagsInput: React.FC<InputComponentProps> = ({
  filter,
  onChange,
  preSelected,
  onApplyStateChange,
}) => {
  const [textInput, setTextInput] = useState<string>("");
  const [tags, setTags] = useState<string[]>([]); // Store tags as an array

  // Using useEffect to set the initial state based on preSelected
  useEffect(() => {
    if (preSelected[filter.name + dvk]) {
      const allTagsInArray = preSelected[filter.name + dvk];

      // Update the state correctly using setTags to handle the tag array
      setTags((prevTags) => {
        // Ensure tags are unique and split into an array
        const newTags = allTagsInArray
          .split(",")
          .map((tag: string) => tag.trim());
        return [...new Set([...prevTags, ...newTags])]; // Combine previous tags with new ones and remove duplicates
      });
    }
  }, [preSelected, filter.name]);

  // Formik hook to handle form state
  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    initialValues: {
      tags: tags,
    },
    validationSchema: Yup.object({
      tags: Yup.array()
        .of(Yup.string().trim())
        .min(1, "At least one tag is required")
        .required("Tags are required"),
    }),
    onSubmit: (values) => {
      const data = {
        tags: Array.isArray(values.tags) ? values.tags.join(",") : "",
      };
    },
  });

  const handleApply = () => {
    onChange(filter.name, formik.values.tags, formik.values.tags.join(","));
  };

  // Update apply state whenever tags change
  useEffect(() => {
    if (onApplyStateChange) {
      onApplyStateChange(formik.values.tags.length === 0, handleApply, "Apply");
    }
  }, [formik.values.tags, onApplyStateChange]);

  return (
    <div className="px-3">
      <p className="p-0 m-0 pb-1">{filter.suffix}</p>

      {/* ChipInput component */}
      <div className="mb-3 py-3 border-bottom">
        <ChipInput
          showRequired={true}
          label={filter.name === "id" ? "Media Id" : "Tags"}
          value={formik.values.tags}
          placeholder={
            filter.name === "id"
              ? "type here to add id"
              : "type here to add tags"
          }
          handleChipChange={(chip: string | string[], action: string) => {
            const currentTags = formik.values.tags || [];
            let updatedTags = [...currentTags];
            if (action === "add") {
              const chipsToAdd = typeof chip === "string" ? [chip] : chip;
              updatedTags = [...new Set([...currentTags, ...chipsToAdd])];
            } else if (action === "remove") {
              // Normalize to array - handle both string and array inputs
              const chipsToRemove = typeof chip === "string" ? [chip] : chip;
              updatedTags = currentTags.filter(
                (t: string) => !chipsToRemove.includes(t)
              );
            } else if (action === "clear") {
              updatedTags = [];
            }

            formik.setFieldValue("tags", updatedTags, true);
            formik.setFieldTouched("tags", true, false);
          }} // touched={formik.touched.tags}  // Corrected touched access
          error={
            formik.errors.tags && typeof formik.errors.tags === "string"
              ? formik.errors.tags
              : undefined
          } // Corrected error access
          onBlur={() => formik.setFieldTouched("tags", true)}
        />
      </div>

      {/* Apply Button */}
      {/* <div className="d-flex justify-content-end">
        <button
          className="btn btn-primary btn-sm text-white"
          disabled={formik.values.tags.length === 0}
          onClick={() => onChange(filter.name, formik.values.tags, formik.values.tags.join(','))}
        >
          APPLY
        </button>
      </div> */}
    </div>
  );
};

export default RenderTagsInput;
